import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Единый баннер для всех упражнений
 * Отображает: заголовок, прогресс, статистику (правильные/ошибки) и кнопку назад
 */
export const ExerciseBanner = ({
  currentIndex = 0,
  totalExercises = 1,
  correct = 0,
  incorrect = 0,
  onExit,
  title = '',
  showProgress = true,
}) => {
  const { t } = useLanguage();

  return (
    <div className="exercise-top-bar">
      <div className="exercise-top-row">
        <div style={{ flex: 1 }}>
          {title && (
            <p style={{ fontSize: 14, color: 'var(--gold)', fontWeight: 700, marginBottom: 4 }}>
              {title}
            </p>
          )}
          {showProgress && (
            <p style={{ fontSize: 13, color: 'rgba(245,244,240,0.4)', fontWeight: 600 }}>
              {currentIndex + 1} / {totalExercises}
            </p>
          )}
        </div>

        <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <div className="exercise-stat-pills">
            <div className="exercise-stat-pill correct">
              <span className="exercise-stat-pill-num">{correct}</span>
              <span className="exercise-stat-pill-label">✓ {t('correct')}</span>
            </div>
            <div className="exercise-stat-pill incorrect">
              <span className="exercise-stat-pill-num">{incorrect}</span>
              <span className="exercise-stat-pill-label">✗ {t('errors')}</span>
            </div>
          </div>

          {onExit && (
            <button onClick={onExit} className="exercise-exit-btn">
              <ChevronLeft size={16} />
              {t('exit')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
